import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const defaultState = () => {
  return {
    agentID: null,
    organisation: {
      id  : null,
      name: null,
    },
    course: null,
    coupon: null,
    session: {
      contactID: null
    },
    contact: null,
    coursesBooked: null
  }
}

export default new Vuex.Store({
  state: defaultState(),
  mutations: {
    setAgentID(state, agentID) {
      state.agentID = agentID;
    },
    setOrganisation(state, organisation) {
      state.organisation = organisation;
    },
    setCourse(state, course) {
      state.course = course;
    },
    setContact(state, contact) {
      state.contact = contact;
    },
    setSession(state, session) {
      state.session = session;
    },
    softReset(state) {
      if( state.coursesBooked == null ) {
        state.coursesBooked = [];
      }
      state.coursesBooked.push(state.course.instance);
      state.course = null;
    },
    resetState(state) {
      Object.assign( state, defaultState() );
    },
    resetCourse(state) {
      state.course = null;
    },
    setSessionContact(state, contactID) {
      state.session.contactID = contactID;
    },
    setCoursesBooked(state, courseIDs) {
      state.coursesBooked = courseIDs;
    },
    setDiscountedPrice(state, discount) {
      state.course.discountedPrice = discount.price;
      state.course.discountID = discount.id;
    },
    setCoupon(state, coupon) {
      state.coupon = coupon;
    }
  },
  actions: {
    setAgentID(context, agentID) {
      context.commit( 'setAgentID', agentID );
    },
    setOrganisation(context, organisation) {
      context.commit( 'setOrganisation', organisation );
    },
    setCourse(context, course) {
      context.commit( 'setCourse', course );
    },
    setContact(context, contact) {
      context.commit( 'setContact', contact );
    },
    setSession(context, session) {
      context.commit( 'setSession', session );
    },
    resetState(context) {
      context.commit( 'resetState' );
    },
    softReset(context) {
      context.commit( 'softReset' );
    },
    resetCourse(context) {
      context.commit( 'resetCourse' );
    },
    setSessionContact(context, contactID) {
      context.commit( 'setSessionContact', contactID );
    },
    setCoursesBooked(context, courseIDs) {
      context.commit( 'setCoursesBooked', courseIDs );
    },
    setDiscountedPrice(context, discount) {
      context.commit( 'setDiscountedPrice', discount );
    },
    setCoupon(context, coupon) {
      context.commit( 'setCoupon', coupon );
    },
  },
  getters:{
    hasLoggedin: (state) => {
      return (state.session.contactID != null);
    },
    hasBooked: (state) => {
      return (
        state.coursesBooked != null
        && state.course != null
        && state.coursesBooked.includes( state.course.instance )
      );
    },
    isBooked: (state) => (courseID) => {
      return (
        state.session.contactID != null
        && state.coursesBooked != null
        && state.coursesBooked.includes( courseID )
      );
    }
  }
})
